export const insuranceBaseData = `
  id
  name
  address {
    street
    number
    zipCode
    city
  }
  dispatchEmail
  phoneNumber
  faxNumber
  email
  splitInvoice
  costObjectNumber
  customCostObjectNumber
  disableSurcharge132gp3
`;
